import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class FileUploadsService {
   generateS3PresignedUrl(data){
    return axios.post(
      API_URL +
        `attachable-files/generate-presigned-url`,
      data,
      {
        headers: authHeader(),
      }
    ); 
   }
}

export default new FileUploadsService();